<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11HdGIY/tc-custom/9780253037688.jpg?1733091423269" alt="This image is the cover for the book Topophrenia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Topophrenia
      </h1>
      <p class="bookDescription body article font2">
        <p></p><p>What is our place in the world, and how do we inhabit, understand, and represent this place to others? <i>Topophrenia </i>gathers essays by Robert Tally that explore the relationship between space, place, and mapping, on the one hand, and literary criticism, history, and theory on the other. The book provides an introduction to spatial literary studies, exploring in detail the theory and practice of geocriticism, literary cartography, and the spatial humanities more generally. The spatial anxiety of disorientation and the need to know one's location, even if only subconsciously, is a deeply felt and shared human experience. Building on Yi Fu Tuan's "topophilia" (or love of place), Tally instead considers the notion of "topophrenia" as a simultaneous sense of place-consciousness coupled with a feeling of disorder, anxiety, and "dis-ease." He argues that no effective geography could be complete without also incorporating an awareness of the lonely, loathsome, or frightening spaces that condition our understanding of that space. Tally considers the tension between the objective ordering of a space and the subjective ways in which narrative worlds are constructed. Narrative maps present a way of understanding that seems realistic but is completely figurative. So how can these maps be used to not only understand the real world but also to put up an alternative vision of what that world might otherwise be? From Tolkien to Cervantes, Borges to More, Topophrenia provides a clear and compelling explanation of how geocriticism, the spatial humanities, and literary cartography help us to narrate, represent, and understand our place in a constantly changing world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert T. Tally
      </h2>
      
      <p class="authorDescription body article"><P><P>Robert T. Tally Jr. is Professor of English at Texas State University. His books include <I>Fredric Jameson: The Project of Dialectical Criticism</I>; <I>Utopia in the Age of Globalization</I>: <I>Space, Representation, and the World System</I>; and <I>Spatiality</I>. </P></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?85d7784c